/**
 * Created by emma on 15/12/14.
 */
import {
    REQUEST_DATA,
    RECEIVE_DATA,
    RECEIVE_ERROR,
    EXPIRED_DATA,
    UPDATE_ITEM,
    DELETE_ITEM
} from './action.js';
import $ from 'jquery';
import {in_array} from 'util/array';

//meta:{viewName,viewItemKey,viewItemsKey,viewOrder}
//store:{items,pagination,fetching}
function data(state = {fetching: false, items: [], total: 0, error: false}, action) {
    var {meta={}, params={page: 1}}=action;
    var {viewItemKey}=meta;
    var result = action.result;
    switch (action.type) {
        case REQUEST_DATA:
            return $.extend({}, state, {
                fetching: true,
                meta: meta,
                params: params,
                error: false
            });
        case RECEIVE_DATA:
            return $.extend({}, state, {
                fetching: false,
                items: result.items,
                total: result.count,
                error: false
            });
        case UPDATE_ITEM:
            var items = state.items, newItems;//items是数组
            var index = in_array(items, action.item, viewItemKey);
            if (index != -1) {
                newItems = [].concat(items.slice(0, index),
                    $.extend({}, items[index], action.item),
                    items.slice(index + 1));
                return $.extend({}, state, {items: newItems});
            }
            return state;
        case RECEIVE_ERROR:
            return $.extend({}, state, {
                fetching: false,
                error: true,
                items: [],
                total: 0,
                message: result.message,
                code: result.code
            });
        case EXPIRED_DATA:
            return $.extend({}, state, {
                fetching: false,
                items: [],
                total: 0,
                meta: {},
                error: false
            });
        default:
            return state;
    }
}

function ajaxData(state = {}, action) {
    var meta = action.meta || {};
    var {viewName}=meta;

    switch (action.type) {
        case REQUEST_DATA:
        case RECEIVE_DATA:
        case RECEIVE_ERROR:
        case EXPIRED_DATA:
        case UPDATE_ITEM:
        case DELETE_ITEM:
            return $.extend({}, state, {
                [viewName]: data(state[viewName], action)
            });
        default:
            return state
    }
}

export default ajaxData;


// WEBPACK FOOTER //
// ./components/redux/ajax/reducer.js